import { PropsWithChildren, useState } from 'react';

import { Button, Icons, Box, Stack } from '@cast/design-system';

type Props = PropsWithChildren<{
  title: string;
  testId: string;
}>;

export const ExpandableDrawerSection = ({ title, children, testId }: Props) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Box data-testid={testId}>
      <Button
        testId={`${testId}-button`}
        variant="ghost"
        fullWidth
        size="lg"
        onClick={() => setIsOpen((open) => !open)}
        sx={{
          justifyContent: 'space-between',
          px: 32,
          py: 24,
          '&:hover': { background: 'transparent', boxShadow: 'none' },
        }}
        endIcon={isOpen ? <Icons.CaretUp /> : <Icons.CaretDown />}
      >
        {title}
      </Button>

      {isOpen ? (
        <Stack gap={8} px={32} mb={24} data-testid={`${testId}-content`}>
          {children}
        </Stack>
      ) : null}
    </Box>
  );
};
